// extracted by mini-css-extract-plugin
export var addButton = "_gz-0";
export var border = "_gz-8";
export var check = "_gz-h";
export var danger = "_gz-6";
export var dropdownContainer = "_gz-1";
export var editModalBody = "_gz-j";
export var footerContainer = "_gz-i";
export var fullWidth = "_gz-a";
export var hide = "_gz-9";
export var icon = "_gz-3";
export var input = "_gz-7";
export var inputFlex = "_gz-b";
export var inputWrapper = "_gz-c";
export var manualFocus = "_gz-5";
export var optionButton = "_gz-4";
export var pillWrapper = "_gz-e";
export var pointer = "_gz-2";
export var showOverflow = "_gz-f";
export var tagsFlex = "_gz-d";
export var xButton = "_gz-g";